import { TimeScale } from 'src/lib/contexts/AnalyticsContext/types'

export const sortDataByDate = (prevData: any, currData: any) => {
  const prevDate = new Date(prevData.date)
  const currDate = new Date(currData.date)
  return prevDate.getTime() - currDate.getTime()
}

export const getTimeIncrement = (selectedTimeScale: TimeScale) => {
  switch (selectedTimeScale) {
    case 'hourly':
      return 60 * 60 * 1000 // 1 hour in milliseconds
    case 'daily':
    default:
      return 24 * 60 * 60 * 1000 // 1 day in milliseconds
  }
}
